import { Button } from "@mui/material";
import { Create as CreateIcon, Delete as DeleteIcon } from '@mui/icons-material';

import { IAdminComment } from "~/providers/admin-interfaces";
import { formateDateAndTime } from "~/utils/utils";
import WysiwygDisplay from "~/components/WysiwygDisplay";

import "./style.less";

interface ICommentItem {
	data: IAdminComment;
	isCzech: boolean;
	hasEdit?: boolean;
	hasRemove?: boolean;
	onRemove?: (comment: IAdminComment) => void;
	onEdit?: (comment: IAdminComment) => void;
}

export default function CommentItem({
	data,
	isCzech,
	hasEdit = false,
	hasRemove = false,
	onRemove = () => {},
	onEdit = () => {},
}: ICommentItem) {
	return <div className="commentItem">
		<div className="commentItem__header">
			<span className="commentItem__title">
				{ data.ownerUserEmail } - <strong>{ formateDateAndTime(new Date(data.updatedAt), isCzech, true) }</strong>
			</span>
			{ (hasEdit || hasRemove) && <span className="commentItem__buttons">
				{ hasRemove && <Button onClick={() => onRemove(data)}>
					<DeleteIcon />
				</Button> }
				{ hasEdit && <Button onClick={() => onEdit(data)}>
					<CreateIcon />
				</Button> }
			</span> }
		</div>
		<WysiwygDisplay className="commentItem__data" html={data.comment} maxHeight={200} />
	</div>;
}
